export const TITULO_PAGINA = 'Alterar Percentuais de Recebimento e Pagamento Direto';
export const SUBTITULO_PAGINA = 'Informe o Processo que deseja alterar os Percentuais.';

export const MAX_LENGTH_NUM_PROCESSO = 11;
export const MINIMO_PALAVRAS_JUSTIFICATIVA = 3;
export const MAX_COUNTER_JUSTIFICATIVA = 500;

export const LABEL_NUMERO_PROCESSO = 'Número do Processo:';
export const LABEL_PERCENTUAL_RECEBIMENTO = 'Percentual de Recebimento';
export const LABEL_PERCENTUAL_PAGAMENTO_DIRETO = 'Percentual de Pagamento Direto';
export const LABEL_JUSTIFICATIVA = 'Justificativa*';
export const LABEL_ALTERAR = 'Alterar';

export const MENSAGEM_ERRO_BUSCA_PROCESSO = 'Nenhum resultado foi encontrado relacionado à sua pesquisa';
export const MENSAGEM_ERRO_VERIFICAR_LANCAMENTO = 'Não foi possível verificar se o processo possui lançamentos na Ficha Financeira. Tente novamente.';
export const MENSAGEM_BLOQUEIO_LANCAMENTO_FICHA_FINANCEIRA = 'Não é possível alterar os percentuais de um processo com lançamentos na Ficha Financeira.';
export const MENSAGEM_SUCESSO_ALTERACAO = 'Percentuais do processo alterados com sucesso.';
export const MENSAGEM_ERRO_ALTERACAO = 'Não foi possível realizar a alteração dos percentuais para este processo.';
export const MENSAGEM_CONFIRMACAO_ALTERACAO = 'Os percentuais deste processo serão alterados. Deseja continuar?';
export const MENSAGEM_ERRO_HISTORICO_AUTOMATICO = 'Percentuais alterados, mas não foi possível registrar o histórico automático desta alteração.';
